<template>
    <div>
        <div class="combo-meal">
            <div class="header-wrapper">
                <div class="header-wrapper__title">{{ wrapperTitle }}</div>
                <div class="header-wrapper__sub">{{ wrapperSubTitle }}</div>
            </div>
            <div class="tab">
                <button :class="['tab-btn', activeName === 'credit' && 'active']" @click="handleBtnChange('credit')">{{ $t('Credit Package') }}</button>
                <div class="gap"></div>
                <button :class="['tab-btn', activeName === 'vip' && 'active']" @click="handleBtnChange('vip')">{{ $t('Unlimited Pass') }}</button>
            </div>
            <div class="number" v-if="activeName === 'vip'">
                <span class="number-name">{{ $t("Number of Students") }}</span>
                <div class="number-btn-group">
                    <button v-for="i in Object.keys(kids)" :key="i" :class="['number-btn-group-item', kidsActive === i && 'active']" @click="kidClick(i)" type="primary">
                        <img v-if="kidsActive === i" class="number-btn-group-item__avatar" src="../assets/img/priceCard/avatar.png" alt="" />
                        <span class="number-btn-text">{{ i }}</span>
                    </button>
                </div>
            </div>
            <div class="card-wrapper">
                <img v-if="isMobile" class="icon" src="../assets/img/priceCard/left.png" @click="handleArrowClick('left')" />
                <PriceCard
                    ref="priceCard"
                    :isActive="priceActive === idx"
                    @mouseenter.native="
                        () => {
                            !isMobile && (priceActive = idx);
                        }
                    "
                    class="card-wrapper__item"
                    :style="{ width: isMobile ? '' : activeName === 'credit' ? '580px' : '379px' }"
                    v-for="(item, idx) in priceList"
                    :key="item.id"
                    :priceInfo="item"
                    :index="isMobile ? priceSelect : idx"
                    :activeName="activeName"
                    :isMobile="isMobile"
                    @btnClick="handlePriceClick(item.id)" />
                <img v-if="isMobile" class="icon" @click="handleArrowClick('right')" src="../assets/img/priceCard/right.png" />
            </div>
        </div>
        <div class="foot">
            <wp-footer></wp-footer>
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import WpFooter from '@/components/WpFooter.vue';
import PriceCard from '../components/PriceCard.vue';

import { loadingData } from '../utils';
import { getUser } from '../store/user';
import { getPlanList, getCreatPlanList, getFaqList, recordClick, getHidePlanList } from '../api';
import { setStore, keys, getStore } from '../store';
import { setUser } from '../store/user';
import i18n from '../locales/i18n';
export default {
    components: {
        NavBar,
        WpFooter,
        PriceCard,
    },
    data() {
        return {
            kids: {
                1: { value: '1', planList: [] },
                2: { value: '2', planList: [] },
                3: { value: '3', planList: [] },
            },
            kidsActive: '1',
            creatPlanList: [],
            faq: {
                active: 0,
                list: [],
            },
            comment: {
                index: 0,
                count: 4,
            },
            user: null,
            btnFlag: false,
            activeName: 'credit',
            priceActive: 0,
            priceSelect: 0,
            isMobile: false,
        };
    },
    created() {
        this.$router.push({ params: { id: '' } });
  },
    mounted() {
        loadingData(async () => {
            this.user = getUser();
            if (this.user) {
                await setUser();
                this.user = getUser();
            }
            // recordClick(1,this.user&&this.user.user_info.user_sn)
            let datas = await Promise.all([getPlanList(1, this.user ? this.user.user_info.user_sn : ''), getCreatPlanList(this.user ? this.user.user_info.user_sn : ''), getFaqList()]);
            this.$set(this.kids[this.kidsActive], 'planList', datas[0]);

            this.creatPlanList = datas[1];
            this.$set(this.faq, 'list', datas[2]);
            this.changePriceSelect()
        });

        window.addEventListener('resize', (ev) => {
            this.deviceWidth();
        });
        this.deviceWidth();
    },
    computed: {
        isMember() {
            if (!this.user) return false;

            if (this.user.user_info.member_status === 0) return false;

            return true;
        },
        wrapperTitle() {
            return this.activeName === 'credit' ? 'Pay-as-You-Go' : 'Unlimited Lesson Plan';
        },
        wrapperSubTitle() {
            return this.activeName === 'credit' ? this.$t(`Enrich kids education and keep them ahead of the curve`) : this.$t(`One Pass that Meets Your Kids Learning Needs`);
        },
        originPriceList() {
            let list = [];
            if (this.activeName === 'credit') {
                list = this.creatPlanList || [];
            } else {
                list = this.kids[this.kidsActive]['planList'];
            }
            return list;
        },
        priceList() {
            return this.isMobile ? [this.originPriceList[this.priceSelect] || {}] : this.originPriceList;
        },
    },
    watch: {
        priceList() {
            this.priceActive = this.originPriceList.length - 1
        }
    },
    methods: {
        handleBtnChange(type) {
            this.activeName = type;
            this.changePriceSelect()
        },
        changePriceSelect() {
            setTimeout(() => {
                this.priceSelect = this.originPriceList.length - 1;
            }, 10);
        },
        handleArrowClick(type) {
            if (type === 'right') {
                this.priceSelect = this.priceSelect === this.originPriceList.length - 1 ? 0 : this.priceSelect + 1;
            } else {
                this.priceSelect = this.priceSelect === 0 ? this.originPriceList.length - 1 : this.priceSelect - 1;
            }
        },
        deviceWidth() {
            const width = (window.screen || {}).width || window.innerWidth || document.innerWidth;
            this.isMobile = width < 768;
        },
        handleScroll() {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var height = this.$refs.elemnt.offsetHeight;
            if (scrollTop > 160 + height) {
                this.btnFlag = true;
            } else {
                this.btnFlag = false;
            }
        },
        toTop() {
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            // const timeTop = setInterval(() => {
            //     document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
            //     if (top <= 250) {
            //         clearInterval(timeTop);
            //     }
            // }, 10);
            document.body.scrollTop = document.documentElement.scrollTop = 400;
        },
        async kidClick(kidNumber) {
            let active = kidNumber.toString();
            if (this.kids[active].planList.length <= 0) {
                await loadingData(async () => {
                    let data = await getPlanList(active, this.user ? this.user.user_info.user_sn : '');
                    this.$set(this.kids[active], 'planList', data);
                });
            }
            this.kidsActive = active;
        },
        // 套餐
        planClick(id) {
            if (!id) {
                this.$message(i18n.t('Package / Credit Package is not selected'));
                return;
            }
            if (!this.user) {
                setStore(keys.redirect, redirect);
                this.$router.push(redirect);
            }
            if (this.isMember) {
                const h = this.$createElement;
                this.$msgbox({
                    customClass: 'boxcss',
                    message: h('p', null, [h('span', null, i18n.t('Please contact our course advisor to upgrade your plan'))]),
                    closeOnClickModal: true,
                    confirmButtonText: i18n.t('Ok'),
                });
                return;
            }
            let redirect = { path: 'paymenthly', query: { id: id, type: 'member' } };
            if (!this.user) setStore(keys.redirect, redirect);
            this.$router.push(redirect);
        },

        // 课程
        creatPlanClick(id) {
            if (!id) {
                this.$message(i18n.t('Package / Credit Package is not selected'));
                return;
            }
            let redirect = { path: 'paymenthly', query: { id, type: 'credit' } };
            if (!this.user) setStore(keys.redirect, redirect);
            this.$router.push(redirect);
        },

        handlePriceClick(id) {
          if (this.activeName === 'credit') {
            this.creatPlanClick(id)
          } else {
            this.planClick(id)
          }
        },

        commentClick(value) {
            let nextIndex = this.comment.index + value;
            if (nextIndex < 0) return;
            if (nextIndex + 3 > this.comment.count) return;

            this.$refs.overContainer.scrollLeft = nextIndex * 330;
            this.comment.index = nextIndex;
        },
    },
};
</script>

<style lang="less" scoped>
.combo-meal {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Inter';
    // overflow-x: hidden;

    :deep(>*) {
        font-family: 'Inter';
        font-style: normal;
    }

    .header-wrapper {
        &__title {
            font-family: 'Inter';
            font-style: normal;
        }
        &_sub {
            font-family: 'Inter';
            font-style: normal;
        }
    }
    .tab {
        width: 261px;
        height: 44px;
        background: #f3f4f6;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px;
        .active {
            background-color: #fff;
        }

        .gap {
            width: 12px;
        }

        &-btn {
            border: none;
            width: 128px;
            height: 36px;
            font-family: 'Inter';
            font-style: normal;
            cursor: pointer;
            background-color: rgba(0, 0, 0, 0);
        }
    }

    .number {
        display: flex;
        align-items: center;

        &-name {
            font-weight: 600;
            font-size: 24px;
            color: #4b4efc;
            letter-spacing: -0.02em;
            font-family: 'Inter';
            font-style: normal;
        }
        &-btn-group {
            height: 32px;
            display: flex;
            align-items: center;
            .active {
                background-color: #4b4efc;
                color: #fff;
                border: none;
            }
            &-item {
                width: 60px;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #fff;
                border: 1px solid #d9d9d9;
                font-family: 'Inter';
                font-style: normal;
                color: #000;
                margin: 0;
                border: 1px solid #d9d9d9;
                &:first-child {
                    border-radius: 5px 0px 0px 5px;
                    border-right: none;
                }
                &:last-child {
                    border-radius: 0px 5px 5px 0px;
                    border-left: none;
                }

                &__avatar {
                    width: 12px;
                    height: 12px;
                    margin-right: 4px;
                    margin-top: -2px;
                }
                span {
                    font-family: 'Inter';
                }
            }
        }
    }
}

@media screen and (min-width: @device) {
    .combo-meal {
        margin-top: 82px;
        margin-bottom: 50px;
        .header-wrapper {
            text-align: center;
            margin-bottom: 36px;
            &__title {
                font-size: 36px;
                color: #111827;
                font-weight: 700;
            }
            &__sub {
                margin-top: 16px;
                font-weight: 400;
                font-size: 16px;
                color: #6b7280;
            }
        }
        .number {
            margin-top: 64px;
            &-btn-group {
                margin-left: 30px;
                &-item {
                    cursor: pointer;
                }
            }
        }
        .card-wrapper {
            margin-top: 64px;
            display: flex;
            padding-bottom: 70px;
            &__item {
                width: 80%;
                &:not(:first-of-type) {
                    margin-left: 40px;
                }
            }
        }
    }
}

@media screen and (max-width: @device) {
    .foot{
			display: none;
		}
    .combo-meal {
        margin-top: 37px;
        padding-bottom: 50px;
        .header-wrapper {
            text-align: center;
            margin-bottom: 12px;
            padding: 0 27.5px;
            &__title {
                font-size: 26px;
                color: #111827;
                font-weight: 700;
            }
            &__sub {
                margin-top: 16px;
                font-weight: 400;
                font-size: 14px;
                color: #6b7280;
            }
        }

        .tab {
            &-btn {
                color: #374151;
                &:active {
                    background-color: #fff;
                }
            }
        }

        .number {
            margin-top: 16px;
            flex-direction: column;
            align-items: center;
            &-btn-group {
                margin-top: 12px;
            }
        }

        .card-wrapper {
            margin-top: 37px;
            display: flex;
            align-items: center;
            justify-content: center;
            &__item {
                width: 80%;
            }
            .icon {
                object-fit: contain;
                padding: 5px;
            }
        }
    }
}
</style>


<style lang="less">
body {
    position: relative;
    overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue